export default "__VITE_ASSET__C0LiI3o5__"